import { render } from "./About.vue?vue&type=template&id=16983c12&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=16983c12&scoped=true&lang=css"
import "./About.vue?vue&type=style&index=1&id=16983c12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16983c12"]])

export default __exports__